import Vue from 'vue'
import router from '@/router'
const app_id = '1201185362'

const plugin = {
  install: (Vue, options) => {
    const ad = {
      isInitialize: false,
      pageKV: {
        // 暂时去掉Web广告
        // my_children: {
        //   type: 'interstitial',
        //   ad_id: '7004338559218035',
        // },
        submit_success: {
          // ad_type: 'interstitial',
          // ad_id_key: 'submit_interstitial',
          // container_id: 'PostAnswerAD'
        },
      },
      // initAD () {
      //   let currentRouter = router.history.current;
      //   let isiPhone = navigator.userAgent.indexOf('iPhone') >= 0;
      //   const pageADKeys = Object.keys(this.pageKV)
      //   console.log('ADisInitialize:', this.isInitialize, isiPhone, currentRouter, pageADKeys);
      //   if (this.isInitialize) {
      //     return;
      //   }
      //   if (isiPhone) {
      //     return;
      //   }  
      //   // H5 SDK 在线文档地址：http://developers.adnet.qq.com/doc/web/js_develop
      //   // 全局命名空间申明TencentGDT对象
      //   window.TencentGDT = window.TencentGDT || [];
        
      //   let params = this.pageKV[currentRouter.name];
      //   console.log('ADParams', currentRouter.name, this.pageKV, params);
      //   if (params && params.type) {
      //     this.isInitialize = true;
      //     this.initialBannerAD(params);
          
      //     // H5 SDK接入全局只需运行一次
      //     this.initADJS()
      //   }
      // },
      // initADJS() {
      //   var doc = document,
      //   h = doc.getElementsByTagName('head')[0],
      //   s = doc.createElement('script');
      //   s.async = true;
      //   s.src = 'https://qzs.gdtimg.com/union/res/union_sdk/page/h5_sdk/i.js';
      //   h && h.insertBefore(s, h.firstChild);
      // },
      // initialBannerAD(params) {
      //   // 广告初始化
      //   console.log('initialBannerAD:',params);
      //   const placement_id = params.placement_id;
      //   const container_id = params.container_id;
      //   window.TencentGDT.push({
      //     app_id: app_id, // {String} - appid - 必填
      //     placement_id: placement_id, // {String} - 广告位id - 必填
      //     type: 'native', // {String} - 原生广告类型 - 必填
      //     // muid: '42a3784b292b220b8b17c5503e12753b',
      //     // muidtype: 1,
      //     count: 1, // {Number} - 拉取广告的数量，默认是3，最高支持10 - 选填
      //     onComplete: function(res) {
      //       console.log('InitBannerADComplete:',res);
      //       if (res && res.constructor === Array) {
      //         let ad = res[0];
      //         console.log('loadInitAD:', ad, res);
      //         // 原生模板广告位调用 window.TencentGDT.NATIVE.renderAd(res[0], 'containerId') 进行模板广告的渲染
      //         // res[0] 代表取广告数组第一个数据
      //         // containerId：广告容器ID
      //         window.TencentGDT.NATIVE.renderAd(ad, container_id);
      //       } else {
      //         console.log('Failed-FetchAD');
      //         // console.log('retryFetchAD-Begin')
      //         // 加载广告API，如广告回调无广告，可使用loadAd再次拉取广告
      //         // 注意：拉取广告频率每分钟不要超过20次，否则会被广告接口过滤，影响广告位填充率
      //         // setTimeout(function() {
      //         //   console.log('retryFetchAD-Start')
      //         //   window.TencentGDT.NATIVE.loadAd(placement_id)
      //         // }, 3000)
      //       }
      //     }
      //   });
      // },
    }

    // 添加到全局
    window.$adManager = Vue.$adManager = ad;
    // 添加到实例
    Vue.prototype.$adManager = ad;
  }
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/ADManager.js